// Footer line under each browser: how far the working language has got in this section

import { cn } from "@/lib/utils"
import { percent, type Coverage, type LanguageInfo } from "../../languages"
import { StatusDot } from "./StatusDot"

export function CoverageBar({ coverage, className }: { coverage: Coverage; className?: string }) {
  const w = (n: number) => `${coverage.total ? (n / coverage.total) * 100 : 0}%`
  return (
    <div className={cn("flex h-1.5 w-full overflow-hidden rounded-full bg-muted", className)}>
      <div className="bg-emerald-500" style={{ width: w(coverage.reviewed) }} />
      <div className="bg-amber-500" style={{ width: w(coverage.unreviewed) }} />
    </div>
  )
}

export function CoverageLine({ language, isSource, coverage, noun }: {
  language: LanguageInfo
  isSource: boolean
  coverage: Coverage
  noun: string // "records", "articles"…
}) {
  return (
    <div className="space-y-1 border-t px-3 py-2 text-[11px] text-muted-foreground">
      <div className="flex items-center gap-1.5">
        <StatusDot status={isSource ? "source" : coverage.missing ? "missing" : coverage.unreviewed ? "unreviewed" : "reviewed"} />
        <span className="font-medium text-foreground">{language.name}</span>
        <span className="flex-1" />
        {isSource
          ? <span>source language · {coverage.total} {noun}</span>
          : <span>
              {coverage.translated}/{coverage.total} translated ({percent(coverage)}%)
              {coverage.unreviewed > 0 && <span className="text-amber-700 dark:text-amber-400"> · {coverage.unreviewed} to review</span>}
            </span>}
      </div>
      {!isSource && coverage.total > 0 && <CoverageBar coverage={coverage} />}
    </div>
  )
}
